import Sort from '@/models/Card/Filter/sort';
import Property from '@/models/Card/Filter/property';

export default class Filter {
  constructor({
    search = '',
    sort = new Sort(),
    property = new Property(),
  } = {}) {
    this.search = search;
    this.sort = sort;
    this.property = property;
  }
}
